var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddSchedule = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5.492 20.278a4.925 4.925 0 1 0 0-9.85 4.925 4.925 0 0 0 0 9.85"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1.883 10.427v-5.54h17.854v8.926L16.351 17.2h-4.925"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4.654 7.964a.308.308 0 1 0 0-.616.308.308 0 0 0 0 .616M7.732 7.964a.308.308 0 1 0 0-.616.308.308 0 0 0 0 .616M10.81 7.964a.308.308 0 1 0 0-.616.308.308 0 0 0 0 .616M13.889 7.964a.308.308 0 1 0 0-.616.308.308 0 0 0 0 .616M16.967 7.964a.308.308 0 1 0 0-.616.308.308 0 0 0 0 .616M10.81 11.35a.308.308 0 1 0 0-.615.308.308 0 0 0 0 .616M13.889 11.35a.308.308 0 1 0 0-.615.308.308 0 0 0 0 .616M13.889 14.736a.308.308 0 1 0 0-.615.308.308 0 0 0 0 .615M16.967 11.35a.308.308 0 1 0 0-.615.308.308 0 0 0 0 .616"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.352 17.2v-3.387h3.386M6.808 3.039a.616.616 0 1 1-1.23 0V1.808a.616.616 0 1 1 1.23 0zM16.043 3.039a.616.616 0 1 1-1.231 0V1.808a.616.616 0 1 1 1.23 0zM17.274 2.423h1.232c.68 0 1.231.244 1.231.924v1.847M8.04 2.423h5.541M1.883 5.194v-1.54c0-.68.55-1.23 1.231-1.23h1.231M3.645 15.352h3.694M5.491 13.505V17.2"
})));
export default SvgAddSchedule;